module.exports = __webpack_public_path__ + "static/media/opciones perfil header slice.84d31bbb.png";